// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"386":"c77feeaf","1108":"1c4acd8d","8083":"f88ba6a2","8810":"bc8a8a01","8859":"1f2987e2"}[chunkId] + ".chunk.css";
};